import DurationFormat from "%/dynamic-component-editor/options/duration-format";
import { formatDuration } from "%/dynamic-components/render-engine/helpers/duration-format";

export const DurationElementMixin = {
  options: [DurationFormat],
  data() {
    return {
      DurationFormat,
    };
  },
  methods: {
    formattedDuration(seconds) {
      return formatDuration(seconds, this.getOptionValue(DurationFormat));
    },
  },
};
